<template>
  <div class="voice-assistant">
    <div class="speaking-line" v-show="isSpeaking"></div>
    <div v-if="oldWorkOrders.length > 0" class="old-work-orders">
      <h3>Old Work Orders (Older than 30 days):</h3>
      <ul>
        <li v-for="order in oldWorkOrders" :key="order.ord_no">
          {{ order.ord_no }} - {{ order.start_dt }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'VoiceAssistant',
  data() {
    return {
      isSpeaking: false,
      isListening: false,
      recognition: null,
      oldWorkOrders: [],
      wakeWord: 'pablo', // Wake word
      listeningTimeout: null, // Timeout for returning to passive state
      listeningDuration: 10000, // Duration to stay active after hearing "Pablo" (10 seconds)
      commands: {
        'hello': 'Hello! How can I help you today?',
        'how are you': 'I’m doing well, thank you!',
        'show work orders older than 30 days': 'Here are the work orders older than 30 days.'
      },
      tasks: {
        'show work orders older than 30 days': async () => {
          try {
            const response = await axios.get('http://localhost:3000/getOldWorkOrders');
            this.oldWorkOrders = response.data;
            this.speak('Here are the work orders older than 30 days.');
          } catch (error) {
            this.speak('Sorry, I encountered an error fetching the old work orders.');
          }
        }
      }
    };
  },
  // async mounted() {
  //   await this.initializeVoiceRecognition();
  // },
  methods: {
    // initializeVoiceRecognition() {
    //   const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    //   if (!SpeechRecognition) {
    //     console.error('Browser does not support Speech Recognition.');
    //     return;
    //   }

    //   this.recognition = new SpeechRecognition();
    //   this.recognition.continuous = true;
    //   this.recognition.lang = 'en-US';

    //   this.recognition.onresult = (event) => {
    //     const transcript = event.results[event.resultIndex][0].transcript.trim().toLowerCase();
    //     console.log('Voice command recognized:', transcript);
    //     this.processVoiceCommand(transcript);
    //   };

    //   this.recognition.onerror = (event) => {
    //     console.error('Speech recognition error', event.error);
    //   };

    //   this.recognition.onstart = () => {
    //     console.log('Voice recognition started');
    //   };

    //   this.recognition.onend = () => {
    //     console.log('Voice recognition ended');
    //     setTimeout(() => this.recognition.start(), 500); // Restart listening after a short delay
    //   };

    //   this.recognition.start();
    // },
    processVoiceCommand(command) {
      console.log('Processing command:', command);

      if (command.includes(this.wakeWord)) {
        // Remove wake word from command
        let cleanCommand = command.replace(this.wakeWord, '').trim();
        cleanCommand = cleanCommand.replace(/[,?!.]/g, '').trim();

        if (!this.isListening) {
          this.isListening = true;
          this.speak('How can I help you?');
          this.resetListeningTimeout();
        } else if (cleanCommand) {
          this.handleCommand(cleanCommand);
          this.resetListeningTimeout();
        }
      } else if (this.isListening) {
        this.handleCommand(command);
        this.resetListeningTimeout();
      }
    },
    handleCommand(cleanCommand) {
      if (this.commands[cleanCommand]) {
        this.speak(this.commands[cleanCommand]);
        this.executeTask(cleanCommand);
      } else {
        this.speak('Sorry, I did not understand that command.');
      }
    },
    async speak(text) {
      const data = { text: text };

      try {
        const response = await axios.post('http://localhost:3000/synthesize', data, {
          responseType: 'arraybuffer'
        });

        const blob = new Blob([response.data], { type: 'audio/mp3' });
        const url = window.URL.createObjectURL(blob);
        const audio = new Audio(url);

        if (this.currentAudio) {
          this.currentAudio.pause();
          this.currentAudio.currentTime = 0;
        }

        this.currentAudio = audio;

        audio.onplay = () => {
          this.isSpeaking = true;
          this.isListening = false; // Pause listening while speaking to prevent feedback
        };
        audio.onended = () => {
          this.isSpeaking = false;
          this.isListening = true; // Resume listening after speaking
          window.URL.revokeObjectURL(url);
        };

        audio.play();
      } catch (error) {
        console.error('Error fetching synthesized speech:', error);
      }
    },
    executeTask(command) {
      if (this.tasks[command]) {
        this.tasks[command]();
      }
    },
    resetListeningTimeout() {
      if (this.listeningTimeout) {
        clearTimeout(this.listeningTimeout);
      }
      this.listeningTimeout = setTimeout(() => {
        this.isListening = false;
      }, this.listeningDuration);
    }
  },
};
</script>

<style scoped>
.voice-assistant {
  position: relative;
}

.speaking-line {
  position: absolute;
  bottom: 20%;
  width: 80%;
  height: 5px;
  background: linear-gradient(90deg, #fff, #8e44ad, #fff);
  animation: move 1s linear infinite;
}

.old-work-orders {
  margin-top: 20px;
}

@keyframes move {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
